import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import AddCircle from '@mui/icons-material/AddCircle';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CircularProgress from '@mui/material/CircularProgress';

import { createSearchParams, useSearchParams, useNavigate } from 'react-router-dom';
import { objectToQueryString, apiHelper, baseUrl } from 'helpers/util';

import ColumnBox from 'components/ColumnBox';
import CardList from 'components/CardList';
import CardItem from 'components/CardItem';
import SmallestHeading from 'components/SmallestHeading';
import SmallHeading from 'components/SmallHeading';


export default function Form() {
    const navigate = useNavigate();
    const [ employees, setEmployees ] = useState([]);

    const loadEmployees = function() {
        const apiParams = {
            "doctype": "User",
            "fields": JSON.stringify(["name", "full_name"]),
            "order_by": "full_name asc",
            "limit": 1000,
            "filters": JSON.stringify([["enabled", "=", 1]])
        }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) { setEmployees(response.json.data); }
            else { console.log(response.json); }
        })
    }

    const openEmployeeReport = function(userName) {
        navigate({ "pathname": "/training_index/employee_report",
            "search": createSearchParams({
                'user_name': userName
            }).toString() });
    }

    useEffect(function() {
        loadEmployees();
    }, [])

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px' }}>
            <ColumnBox>
                <SmallHeading>Members</SmallHeading>
                <CardList>
                    { employees.map(p => (
                        <CardItem sx={{ 'cursor': 'pointer' }} onClick={() => openEmployeeReport(p.name)}>
                            <SmallestHeading>{p.full_name}</SmallestHeading>
                            <Box>{p.name}</Box>
                        </CardItem>
                    )) }
                </CardList>
            </ColumnBox>
        </Box>
    );
}
